import Skrollite from '../../../components/skrollite/script';

class SkrolliteController {

	components = {
		skrollite: null,
	};

	flags = {
		isEnabled: false,
		isPageIn: false
	};

	timeouts = {
		enable: null
	};

	// <==]--------------------------->

	initialize() {
		this.components.skrollite = new Skrollite();
	}

	// enable / disable

	enable(delay = 320) {
		if (!this.flags.isEnabled) {
			this.flags.isEnabled = true;

			// skrollite may want to be delayed to a general page effect like a fade in
			clearTimeout(this.timeouts.enable);
			this.timeouts.enable = setTimeout(() => {
				this.components.skrollite.enable();
				this.timeouts.enable = null;
			}, delay);
		}
	}

	disable() {
		if (this.flags.isEnabled) {
			this.flags.isEnabled = false;
			this.components.skrollite.disable();

		}
	}

	// page in and out

	pageIn() {
		if (!this.flags.isPageIn) {
			this.flags.isPageIn = true;
			this.enable();
		}
	}

	pageOut() {
		if (this.flags.isPageIn) {
			this.flags.isPageIn = false;
			this.disable();
		}
	}

	//

	pageUpdate() {
		if (this.components.skrollite) {
			this.components.skrollite.pageUpdate();
		}
	}

}

export default new SkrolliteController();
